<template>
  <div class="download-container">
    <div class="app-picture">

      <!--頂部欄1111-->
      <div class="top-nav-container">
        <span class="title-style">App下載</span>
        <span @click="backClick" style="position: absolute;left: 10px">返回</span>
      </div>

      <div class="client-download-container" style="margin-top: 10%"></div>


      <div
        @click="showAndroidDownload"
        class="client-download-container-Android" style="margin-top: 38%">
        <span class="downloadSpan"><img src="../assets/Android-logo.png" width="15%">Android下載</span>
        <!--
            <a href="https://play.google.com/store/apps/details?id=com.mysread.mys">Android下載</a>
      -->
      </div>

      <transition-group name="slide" tag="div">
        <div  key="B" v-if="showAndroid" @click="androidDownload('https://play.google.com/store/apps/details?id=top.dober.c')"
             class="client-download-container-Android">
          <span class="downloadSpan"><img src="../assets/Android-logo.png" width="15%">新版本</span>
        </div>

        <div key="C" v-if="showAndroid" @click="androidDownload('https://b.mysread.com/app/liyi.apk')"
             class="client-download-container-OldAndroid" style="margin-top: 0%">
          <span class="downloadSpan"><img src="../assets/Android-logo.png" width="18%">立異老版本</span>
        </div>


      </transition-group>


      <div @click="iOSDownload" class="client-download-container-Ios" style="margin-top: 0%">
        <!--      <a href="https://apps.apple.com/us/app/id1323155648">iOS下載</a>-->
        <span class="downloadSpan"><img src="../assets/Ios-logo.png" width="8%">&nbsp;&nbsp;iOS下載</span>
      </div>

      <!--      <div class="client-download-container-Ios" style="margin-top: 2%">
              <Popup :visible="popupVisible" :content="popupContent" @close="closePopup"/>
              <span class="downloadSpan" @click="showPopup"><img src="../assets/Ios-logo.png"
                                                                 width="8%">&nbsp;&nbsp;iOS找回</span>
            </div>-->

      <div class="client-download-container" style="margin-top: 78%"></div>
    </div>
  </div>
</template>

<script>
import Popup from "./Popup.vue";

import axios from "axios";

export default {
  name: "DownloadVue",
  components: {
    Popup
  },
  data() {
    return {
      showAndroid: false,
      googleAndroidDownload: "",
      googleIosDownload: "",
      popupVisible: false,
      popupContent: '這是壹個ios找回的頁面彈窗',
    };
  },
  methods: {
    showAndroidDownload(){
      this.showAndroid = !this.showAndroid;
    },
    //返回
    backClick: function () {
      this.$router.go(-1);
    },
    showPopup() {
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
    },

    androidDownload: function (finialUrl) {
      fbq("track", "androidDownloadButtonClick");
      _lt('send', 'cv', {
        type: 'azDownload'
      }, ['da099686-7375-45bd-9b84-e87f95c05af4']);
      ttq.track('azDownload')
      this.googleAndroidDownload();
      //var finialUrl = "https://play.google.com/store/apps/details?id=top.dober.c";
      window.open(finialUrl);
    },


    iOSDownload: function () {
      fbq("track", "iOSDownloadButtonClick");
      _lt('send', 'cv', {
        type: 'Conversion'
      }, ['da099686-7375-45bd-9b84-e87f95c05af4']);
      ttq.track('iosDownload')
      this.googleIosDownload();
      this.handleDownload()
    },

    handleDownload: function () {
      var baseUrl = "https://mys.onelink.me/X0px?af_xp=custom&pid=ly-h5&deep_link_value=goto_read_page&deep_link_sub1=";
      var sub = "";
      var bookId = this.$route.query.bookId;
      var chapterId = this.$route.query.chapterId;
      var bookName = this.$route.query.bookName;
      if (typeof (bookId) !== 'undefined' && bookId !== '') {
        sub += bookId;
        if (typeof (chapterId) !== 'undefined' && chapterId !== '') {
          sub += ',' + chapterId;
        } else {//參數缺失，直接後退
          this.backClick();
          return
        }
        if (typeof (bookName) !== 'undefined' && bookName !== '') {
          sub += ',' + bookName;
        } else {
          this.backClick();
          return
        }
        sub = encodeURIComponent(sub)
        var finialUrl = baseUrl + sub;
        window.open(finialUrl);
      } else {//不存在書本，查詢最新的壹條數據
        const params = new URLSearchParams();
        params.append("language", "zh-Hant");
        params.append("dev", "h5");
        params.append("uuid", "123456");
        params.append("ver", "1.0");
        params.append("ac", "getLastIndexPromote");
        this.$http.post(axios.baseURL, params).then((res) => {
          this.isRequest = false;
          if (res.data.status) {
            const bookId = res.data.data.book_id;
            const chapterId = res.data.data.chapter_id;
            const bookName = res.data.data.book_name;
            const sub = bookId + "," + chapterId + "," + bookName;
            const finialUrl = baseUrl + encodeURIComponent(sub);
            window.open(finialUrl);
          } else {
            alert(res.data.msg);
          }
        });
      }
      //window.location.href = finialUrl;

    }
  },
  created() {
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", "AW-863726682");

    //Event snippet for 瀏覽“下載APP”頁面
    gtag("event", "conversion", {
      send_to: "AW-863726682/opJECJuGh-wBENrY7ZsD",
    });
    console.log(
      "google 像素 進入 app下載界面: 'AW-863726682/opJECJuGh-wBENrY7ZsD"
    );

    //Event snippet for 點擊“安卓APP下載”按鈕
    this.googleAndroidDownload = function gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-863726682/0TdgCOGFiOwBENrY7ZsD",
        event_callback: callback,
      });
      console.log(
        "google 像素 android app 下載按鈕點擊: AW-863726682/0TdgCOGFiOwBENrY7ZsD"
      );
      return false;
    };

    //Event snippet for 點擊“IOS APP下載”按鈕
    this.googleIosDownload = function gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-863726682/34yMCNvfquwBENrY7ZsD",
        event_callback: callback,
      });
      console.log(
        "google 像素 ios app 下載按鈕點擊: AW-863726682/34yMCNvfquwBENrY7ZsD"
      );
      return false;
    };


    //facebook像素
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    fbq("init", "1025830745421256");
    fbq("track", "PageView");

    //line像素
    (function (g, d, o) {
      g._ltq = g._ltq || [];
      g._lt = g._lt || function () {
        g._ltq.push(arguments)
      };
      var h = location.protocol === 'https:' ? 'https://d.line-scdn.net' : 'http://d.line-cdn.net';
      var s = d.createElement('script');
      s.async = 1;
      s.src = o || h + '/n/line_tag/public/release/v1/lt.js';
      var t = d.getElementsByTagName('script')[0];
      t.parentNode.insertBefore(s, t);
    })(window, document);
    _lt('init', {
      customerType: 'lap',
      tagId: 'da099686-7375-45bd-9b84-e87f95c05af4'
    });
    _lt('send', 'pv', ['da099686-7375-45bd-9b84-e87f95c05af4']);
    //轉換代碼
    _lt('send', 'cv', {
      type: 'goDownload'
    }, ['da099686-7375-45bd-9b84-e87f95c05af4']);

    //tk像素
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e
      }, ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a)
      };
      ttq.load('CLULPKRC77UDM51DRCEG');
      ttq.page();
    }(window, document, 'ttq');
    ttq.track('Download')


  },
};
</script>

<noscript>
<img height="1" width="1" style="display:none"
     src="https://www.facebook.com/tr?id=1025830745421256&ev=PageView&noscript=1"/>
<img height="1" width="1" style="display:none"
     src="https://tr.line.me/tag.gif?c_t=lap&t_id=da099686-7375-45bd-9b84-e87f95c05af4&e=pv&noscript=1"/>
</noscript>

<style scoped>
.download-container {
  max-width: 480px;
  margin: 0 auto;
}

.client-download-container {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  flex-direction: column;
}

.client-download-container-Android {
  text-align: center;
  margin-left: 30%;
  display: flex;
  flex-direction: column;
}

.client-download-container-OldAndroid {
  text-align: center;
  margin-left: 40%;
  display: flex;
  flex-direction: column;
}

.client-download-container-Ios {
  text-align: center;
  margin-left: 30%;
  display: flex;
  flex-direction: column;
}

.client-download-container .downloadSpan {
  margin-top: 10px;
  background-color: firebrick;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: white;
  line-height: 30px;
}

.client-download-container-Android .downloadSpan {
  margin-top: 10px;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: black;
  line-height: 30px;
}

.client-download-container-OldAndroid .downloadSpan {
  margin-top: 10px;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: black;
  line-height: 30px;
}

.client-download-container-Ios .downloadSpan {
  margin-top: 10px;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: black;
  line-height: 30px;
}

.client-download-container .downloadSpan:active {
  background-color: gray;
}

.app-picture {
  background-image: url(../assets/downloadApp-picture.png);
  background-size: cover; /* 或 contain */
  background-position: center; /* 確保圖像居中 */
  background-repeat: no-repeat; /* 防止圖像重復 */
  height: 100vh; /* 視口高度的100% */
  width: 100vw; /* 視口寬度的100% */

}

/*動畫效果*/
/* 定義下拉動畫 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
/*動畫效果*/

</style>



// WEBPACK FOOTER //
// src/components/DownloadVue.vue